/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["@media (max-width:425px){.button-size[_ngcontent-%COMP%]{font-size:12px;height:40px}}"];
export { styles as styles };

